import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('yearlySumChart', {
        template: require('./yearlySumChartComponent.html'),
        bindings: {
            statisticalForecast: "<",
            pmForecast: "<",
            parameters: "<",
        },
        controller: ['$scope', angularServicesNames.$translate, 'PPGChartAndTableService', 'dtpChartService', 'ChartsConfig', 'calculationPPGService', 'debounce',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                PPGChartAndTableService: $TSFixMe,
                dtpChartService: $TSFixMe,
                ChartsConfig: $TSFixMe,
                calculationPPGService: $TSFixMe,
                debounce: $TSFixMe
            ) {
                var $ctrl = this;

                $scope.$on('LanguageChanged', () => resetChartTranslations());
                resetChartTranslations();
                function resetChartTranslations() {
                    $translate(['CHART_SERIES.FORECAST_BASE', 'CHART_SERIES.FORECAST_AFTER_FACTS'])
                        .then(function (translations: $TSFixMe) {
                            $ctrl.datasetOverride = [
                                {
                                    label: translations["CHART_SERIES.FORECAST_BASE"],
                                    type: 'bar'
                                },
                                {
                                    label: translations["CHART_SERIES.FORECAST_AFTER_FACTS"],
                                    type: 'bar'
                                }];
                        });
                }

                $ctrl.chartOptions = {
                    scales: {
                        yAxes: [{
                            ticks: { suggestedMin: 0 }
                        }]
                    }
                }

                $ctrl.$onInit = function () {
                    $scope.$watch('$ctrl.pmForecast', debounce(function (newVal: $TSFixMe) {
                        if (!newVal)
                            return;

                        if (!$ctrl.statisticalForecast) {
                            $ctrl.statisticalForecast = [];
                        }

                        var statisticalForecastYearlySum = calculationPPGService.sumBy($ctrl.statisticalForecast, $ctrl.parameters.forecastStartDate, function (month: $TSFixMe) { return month == 0; });
                        var pmForecastYearlySum = calculationPPGService.sumBy($ctrl.pmForecast, $ctrl.parameters.forecastStartDate, function (month: $TSFixMe) { return month == 0; });

                        $ctrl.labels = PPGChartAndTableService.prepareLabelsToPPG($ctrl.parameters.forecastStartDate, $ctrl.parameters.forecastEndDate);
                        $ctrl.dataToPPGChart = [
                            statisticalForecastYearlySum,
                            pmForecastYearlySum
                        ];
                    }), 300);
                };
            }]
    });

})(angular.module('topline.modules'));